import { HeaderScopePortal } from "@/components/layout/header-scope-slot";
import { ShopScopeSelect } from "@/components/layout/shop-scope-select";
import { ReportingPeriodSelect } from "@/components/patterns/reporting-period-select";
import { ReportingTimeZoneSelect } from "@/components/patterns/reporting-time-zone-select";
import { useReportingPeriodStore } from "@/stores/reporting-period";
import { useReportingTimeZoneStore } from "@/stores/reporting-time-zone";

interface ReportingFiltersProps {
  /** Resource reports follow their own Shop; only workspace reports put the scope in the header. */
  scope?: "workspace" | "resource";
}

export function ReportingFilters({ scope = "workspace" }: ReportingFiltersProps) {
  const period = useReportingPeriodStore((state) => state.period);
  const setPeriod = useReportingPeriodStore((state) => state.setPeriod);
  const timeZone = useReportingTimeZoneStore((state) => state.timeZone);
  const setTimeZone = useReportingTimeZoneStore((state) => state.setTimeZone);
  return (
    <div data-reporting-filters className="flex max-w-full flex-wrap items-center gap-2">
      <ReportingTimeZoneSelect value={timeZone} onValueChange={setTimeZone} />
      <ReportingPeriodSelect value={period} timeZone={timeZone} onValueChange={setPeriod} />
      {scope === "workspace" ? (
        <HeaderScopePortal>
          <ShopScopeSelect />
        </HeaderScopePortal>
      ) : null}
    </div>
  );
}
